import styled from 'styled-components';
import { ConversationReset } from './ConversationReset';
import { UserInput } from './UserInput';
import { Disclaimer } from './Disclaimer';

const FooterDiv = styled.div`
    flex-shrink: 0; padding-top: 20px;
    @media (max-width: 768px) {
        padding-top: 15px;
    }
`

export const Footer: React.FC = () => {
    return (
        <FooterDiv className="footer">
            <ConversationReset />
            <UserInput />
            <Disclaimer />
        </FooterDiv>
    )
}